export const REQUEST_SIGNATURE = 'REQUEST_SIGNATURE'
export const RECEIVE_SIGNATURE = 'RECEIVE_SIGNATURE'
export const REQUEST_SAVE_SIGNATURE = 'REQUEST_SAVE_SIGNATURE'
export const RECEIVE_SAVE_SIGNATURE = 'RECEIVE_SAVE_SIGNATURE'
export const RESET_PATIENT = 'RESET_PATIENT'
